import { render, staticRenderFns } from "./ot-settings-documents-index.vue?vue&type=template&id=d80d1f72&scoped=true&"
import script from "./ot-settings-documents-index.vue?vue&type=script&lang=ts&"
export * from "./ot-settings-documents-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-settings-documents-index.vue?vue&type=style&index=0&id=d80d1f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d1f72",
  null
  
)

export default component.exports